import { supabase } from '@/lib/supabase'
import type { Region, RegionCreate, RegionUpdate } from '@/types'

export async function fetchRegionsByNation(nationId: string): Promise<Region[]> {
  const { data, error } = await supabase
    .from('regions')
    .select('*')
    .eq('nation_id', nationId)
    .order('name', { ascending: true })

  if (error) {
    throw error
  }

  return data as Region[]
}

export async function fetchRegion(id: string): Promise<Region> {
  const { data, error } = await supabase.from('regions').select('*').eq('id', id).single()

  if (error) {
    throw error
  }

  return data as Region
}

export async function createRegion(region: RegionCreate): Promise<Region> {
  const { data, error } = await supabase.from('regions').insert(region).select().single()

  if (error) {
    throw error
  }

  return data as Region
}

export async function updateRegion(id: string, updates: RegionUpdate): Promise<Region> {
  const { data, error } = await supabase
    .from('regions')
    .update(updates)
    .eq('id', id)
    .select()
    .single()

  if (error) {
    throw error
  }

  return data as Region
}

export async function deleteRegion(id: string): Promise<void> {
  const { error } = await supabase.from('regions').delete().eq('id', id)

  if (error) {
    throw error
  }
}
